import { render, staticRenderFns } from "./catContact.vue?vue&type=template&id=b595cf62&scoped=true"
import script from "./catContact.vue?vue&type=script&lang=js"
export * from "./catContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b595cf62",
  null
  
)

export default component.exports